import React from "react";
import { useTranslation } from "react-i18next";

export default function EmptyCashoutButtonCore() {
	const { t } = useTranslation("mybets");

	return (
		<button
			className="card--bet__btn card--bet__btn--alternate btn btn--sml btn--cashout btn--icon"
			disabled
		>
			{t<string>("ITEM.CASHOUT")}
		</button>
	);
}
